import { Relevance, SnippetDesignMatchResponse } from './types'

export const SNIPPETS_LOAD = 'SNIPPETS_LOAD'
export const snippetsLoad = (
  accountId: string,
  projectId: string,
  moduleName: string,
  recordId: string
) => ({
  type: SNIPPETS_LOAD,
  accountId,
  projectId,
  moduleName,
  recordId
})

export const SNIPPETS_LOAD_SUCCESS = 'SNIPPETS_LOAD_SUCCESS'
export const snippetsLoadSuccess = (
  data: SnippetDesignMatchResponse
): SnippetsLoadSuccessAction => ({
  type: SNIPPETS_LOAD_SUCCESS,
  data: data
})

export const SNIPPETS_LOAD_FAILURE = 'SNIPPETS_LOAD_FAILURE'
export const snippetsLoadFailure = (
  error: Error
): SnippetsLoadFailureAction => {
  return {
    type: SNIPPETS_LOAD_FAILURE,
    error
  }
}

export const SNIPPET_RELEVANCE_FEEDBACK = 'SNIPPET_RELEVANCE_FEEDBACK'
export const snippetRelevanceFeedback = (
  accountId: string,
  projectId: string,
  moduleName: string,
  recordId: string,
  productId: string,
  matchId: string,
  relevance: Relevance,
  userId: string
): SnippetRelevanceFeedbackAction => ({
  type: SNIPPET_RELEVANCE_FEEDBACK,
  accountId,
  projectId,
  moduleName,
  recordId,
  productId,
  matchId,
  relevance,
  userId
})

// INTERFACEs
export interface SnippetsLoadAction {
  type: typeof SNIPPETS_LOAD
  accountId: string
  projectId: string
  moduleName: string
  recordId: string
}

interface SnippetsLoadSuccessAction {
  type: typeof SNIPPETS_LOAD_SUCCESS
  data: any
}

interface SnippetsLoadFailureAction {
  type: typeof SNIPPETS_LOAD_FAILURE
  error: Error
}

export interface SnippetRelevanceFeedbackAction {
  type: typeof SNIPPET_RELEVANCE_FEEDBACK
  accountId: string
  projectId: string
  moduleName: string
  recordId: string
  productId: string
  matchId: string
  relevance: Relevance
  userId: string
}
